import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../../layout";
import FormTextField from "../../../components/form/text";
import { useNavigate } from "react-router-dom";
import successToast from "../../../components/toast/successToast";
import errorToast from "../../../components/toast/errorToast";
import { FormDropDown } from "../../../components/form/dropdown";
import { api } from "../../../redux/apis/api";

const CreateRoles = () => {
  const naviagte = useNavigate();
  const initialValues = {
    name: "",
    type: "",
    permissions: {
      Module: {
        read: "read",
        write: "write",
        all_data: "all_data",
        only_associated: "only_associated",
      },
      employee: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      company: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      lead: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      customer: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      product: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      order: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      marketing_material: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      employee_live_tracking: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      lead_activity: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      customer_activity: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      employee_request: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      payment: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      settings: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      tile_layer: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
      expense: {
        read: false,
        write: false,
        all_data: false,
        only_associated: false,
      },
    },
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    const submitValue = { ...values };

    if (submitValue.permissions?.Module) {
      delete submitValue.permissions.Module;
    }

    const finalData = {
      name: submitValue?.name ?? "",
      type: submitValue?.type ?? "",
      ...submitValue.permissions,
    };

    console.log(finalData, "finalData");
    api
      .post(`/ffadmin/role/create`, finalData)
      .then((response) => {
        successToast(response.message);
        console.log(response, "response");
        naviagte(`/admin/roles/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const TypeOptions = [
    { label: "Admin", value: "admin" },
    { label: "Employee", value: "employee" },
  ];

  const modelLabels = {
    employee: "Employee",
    company: "Company",
    lead: "Lead",
    customer: "Customer",
    product: "Product",
    order: "Order",
    marketing_material: "Marketing Material",
    employee_live_tracking: "Employee Live Tracking",
    lead_activity: "Lead Activity",
    customer_activity: "Customer Activity",
    employee_request: "Employee request",
    payment: "Payment",
  };

  return (
    <MainLayout>
      <section className="h-full overflow-auto px-3">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                <h2 className="text-xl font-semibold capitalize">
                  Admin roles - Create
                </h2>
                <div className="flex gap-3 items-center">
                  <button
                    onClick={() => naviagte("/admin/roles/list")}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Create
                  </button>
                </div>
              </div>
              <section className="w-full max-w-[40rem]">
                <div className="my-4">
                  <FormTextField
                    name={"name"}
                    label={"role name"}
                    placeholder={`Enter role name`}
                  />
                </div>
                <div className="my-4">
                  <FormDropDown
                    name={"type"}
                    label={"type"}
                    options={TypeOptions}
                  />
                </div>

                <div>
                  {Object.keys(values.permissions).map((modelKey) => (
                    <div key={modelKey} className="flex justify-between">
                      <div className="p-2 w-full max-w-[16rem]">
                        {(modelLabels[modelKey] || modelKey) === "Module" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            Module Name
                          </p>
                        ) : (
                          modelLabels[modelKey] || modelKey
                        )}
                      </div>

                      <div className="p-2 w-full max-w-[5rem]">
                        {values?.permissions[modelKey].read === "read" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            Read
                          </p>
                        ) : (
                          <Field
                            disabled={values?.permissions[modelKey].write}
                            type="checkbox"
                            name={`permissions.${modelKey}.read`}
                          />
                        )}
                      </div>

                      <div className="p-2  w-full max-w-[5rem]">
                        {values?.permissions[modelKey].write === "write" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            write
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={values.permissions[modelKey].write}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.write`,
                                checked
                              );
                              if (checked) {
                                setFieldValue(
                                  `permissions.${modelKey}.read`,
                                  true
                                );
                              }
                            }}
                          />
                        )}
                      </div>
                      <div className="p-2 w-full max-w-[5rem]">
                        {values?.permissions[modelKey].all_data ===
                        "all_data" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            All data
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={values.permissions[modelKey].all_data}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.all_data`,
                                checked
                              );
                              if (checked) {
                                setFieldValue(
                                  `permissions.${modelKey}.only_associated`,
                                  false
                                );
                              }
                            }}
                          />
                        )}
                      </div>

                      <div className="p-2 w-full max-w-[8rem]">
                        {values?.permissions[modelKey].only_associated ===
                        "only_associated" ? (
                          <p className="text-nowrap pb-2 text-lightGreyText">
                            only associated
                          </p>
                        ) : (
                          <input
                            type="checkbox"
                            checked={
                              values.permissions[modelKey].only_associated
                            }
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setFieldValue(
                                `permissions.${modelKey}.only_associated`,
                                checked
                              );
                              if (checked) {
                                // Uncheck all_data if only_associated is selected
                                setFieldValue(
                                  `permissions.${modelKey}.all_data`,
                                  false
                                );
                              }
                            }}
                          />
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </section>
    </MainLayout>
  );
};

export default CreateRoles;
